import { connect } from 'react-redux';
import MultipleEnrollment from './MultipleEnrollment';
import { ApplicationState } from '../../../../state/store';
import {
  getEnrollmentType,
  getTemplateUploadError,
  getTemplateUploadStatus,
} from '../../../../state/enrollment/enrollmentSelectors';
import {
  setActiveStep,
  uploadTemplateFile,
} from '../../../../state/enrollment/enrollmentActions';

const mapStateToProps = (state: ApplicationState) => ({
  enrollmentType: getEnrollmentType(state),
  templateUploadStatus: getTemplateUploadStatus(state),
  templateUploadError: getTemplateUploadError(state),
});

const mapDispatchToProps = {
  uploadTemplateFile,
  setActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleEnrollment);
